<template>
    <div class="ah-page business-tax-txt-viewer-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>營業稅媒體檔檢視器</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="line-viewer">
            <div class="line-viewer-set">
                <div v-if="parsedLine" class="text-row">
                    <div class="data-section" v-for="field in txtFormat" :key="field.key">
                        <div class="field-label">{{ field.label }}</div>
                        <div v-if="parsedLine[field.key]" class="field-data">{{ parsedLine[field.key] }}</div>
                        <div v-else class="field-data">
                            <span v-for="(n, index) in field.length" :key="`w-${field.key}-${index}`">_</span>
                        </div>
                        <!-- <div class="field-label">{{ field.label }}</div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="split-layout">
            <div class="editor">
                <div class="line-numbers" ref="lineNumbersDiv">
                    <span v-for="n in totalLines" :key="`line-${n}`" :class="{ active: n === focusLineNumber }">{{ n }}</span>
                </div>
                <textarea
                    ref="textarea"
                    class="textarea"
                    placeholder="請貼上媒體檔TXT內容"
                    @mouseup="updateLineInfo"
                    @click="updateLineInfo"
                    @keyup="updateLineInfo"
                    @input="onInputTextarea"
                    @scroll="handleTextareaScroll"
                ></textarea>
            </div>
            <div>
                <div class="left-content">
                    <div class="def-table">
                        <table>
                            <thead>
                            <tr>
                                <th style="width: 160px;">欄位名稱</th>
                                <!-- <th>英文變數名稱</th> -->
                                <th style="width: 130px;">資料 (第{{ focusLineNumber }}筆)</th>
                                <th>說明</th>
                                <th style="width: 45px;">起始</th>
                                <th style="width: 45px;">結束</th>
                                <th style="width: 45px;">長度</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="field in txtFormat" :key="field.key">
                                <td><span v-if="field.chtNumber">({{ field.chtNumber }}) </span>{{ field.label }}</td>
                                <!-- <td><code>{{ field.key }}</code></td> -->
                                <td><div class="data-field">{{ parsedLine ? parsedLine[field.key] : '' }}</div></td>
                                <td>
                                    <template v-if="field.note">
                                        <div v-for="(line, index) in field.note" :key="`note-line-${index}`">{{ line }}</div>
                                    </template>
                                </td>
                                <td>{{ field.start }}</td>
                                <td>{{ field.end }}</td>
                                <td>{{ field.length }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    components: {
    },
    data() {
        return {
            totalLines: 0,
            focusLineNumber: null,
            focusLineTxt: null,
            parsedLine: null,
            activeTab: 'def', // def | line
            txtFormat: [
                {
                    start: 1,
                    end: 2,
                    length: 2,
                    chtNumber: '一',
                    label: '格式代號',
                    key: 'formatCode',
                },
                {
                    start: 3,
                    end: 11,
                    length: 9,
                    chtNumber: '二',
                    label: '營業人稅籍編號',
                    key: 'taxId',
                },
                {
                    start: 12,
                    end: 18,
                    length: 7,
                    chtNumber: '三',
                    label: '流水號',
                    key: 'serialNo',
                    note: ['應按順序編列流水號不得有重覆情形。'],
                },
                {
                    start: 19,
                    end: 23,
                    length: 5,
                    chtNumber: '四',
                    label: '資料所屬年月',
                    key: 'yearMonth',
                    note: ['發票、折讓...開立之年月。'],
                },
                {
                    start: 24,
                    end: 31,
                    length: 8,
                    chtNumber: '五',
                    label: '買受人統編',
                    key: 'buyerId',
                },
                {
                    start: 32,
                    end: 39,
                    length: 8,
                    chtNumber: '七',
                    label: '銷售人統編',
                    key: 'sellerId',
                },
                {
                    start: 40,
                    end: 41,
                    length: 2,
                    chtNumber: '九',
                    label: '發票字軌',
                    key: 'invoicePrefix',
                },
                {
                    start: 42,
                    end: 49,
                    length: 8,
                    chtNumber: '十',
                    label: '發票號碼',
                    key: 'invoiceNo',
                },
                {
                    start: 50,
                    end: 61,
                    length: 12,
                    chtNumber: '十五',
                    label: '銷售額',
                    key: 'amt',
                    note: [
                        '二聯式收銀機統一發票、及員工出差取得之火（汽）車、高鐵、船舶、飛機等收據或票根之進項憑證，"銷售額應內含營業稅額"。',
                        '(作廢發票之銷售額應為零。)',
                    ],
                },
                {
                    start: 62,
                    end: 62,
                    length: 1,
                    chtNumber: '十六',
                    label: '課稅別',
                    key: 'taxType',
                    note: ['1:應稅', '2:零稅率', '3:免稅', 'F:作廢發票', 'D:空白發票'],
                },
                {
                    start: 63,
                    end: 72,
                    length: 10,
                    chtNumber: '十七',
                    label: '營業稅額',
                    key: 'tax',
                    note: [
                        '銷售額欄項已依規定含營業稅額或採特種稅額計算者，本欄項應以零表示。',
                        '(作廢發票之營業稅額應為零。)',
                    ],
                },
                {
                    start: 73,
                    end: 73,
                    length: 1,
                    chtNumber: '十八',
                    label: '扣抵代號',
                    key: 'payCode',
                    note: [
                        '1:進項可扣抵之進貨及費用',
                        '2:進項可扣抵之固定資產',
                        '3:進項不可扣抵之進貨及費用',
                        '4:進項不可扣抵之固定資產',
                        '空白:銷項憑證',
                    ],
                },
                {
                    start: 74,
                    end: 78,
                    length: 5,
                    chtNumber: null,
                    label: '空白',
                    key: 'space',
                },
                {
                    start: 79,
                    end: 79,
                    length: 1,
                    chtNumber: '十九',
                    label: '特種稅額稅率',
                    key: 'spacialTax',
                    note: ['(Sokuji 未使用)'],
                },
                {
                    start: 80,
                    end: 80,
                    length: 1,
                    chtNumber: '二十',
                    label: '彙加註記',
                    key: 'memo',
                    note: ['(Sokuji 未使用)'],
                },
                {
                    start: 81,
                    end: 81,
                    length: 1,
                    chtNumber: '二十一',
                    label: '通關方式註記',
                    key: 'passCode',
                    note: ['(Sokuji 未使用)'],
                },
            ],
        };
    },
    mounted() {
        // this.$refs.textarea.value = ``;
        this.updateLineNumbers();
        this.$nextTick(() => {
            this.handleTextareaScroll();
        });
    },
    methods: {
        updateLineInfo() {
            const { textarea } = this.$refs;
            const text = textarea.value;
            const caretPos = textarea.selectionStart;

            // 取得游標前的文字，並分割成行
            const lines = text.split('\n');
            const beforeCaret = text.substring(0, caretPos);
            const currentLineIndex = beforeCaret.split('\n').length - 1;
            const currentLineText = lines[currentLineIndex] || '';

            this.parsedLine = this.parseLine(currentLineText);
            this.focusLineNumber = currentLineIndex + 1;
            this.focusLineTxt = currentLineText;
        },
        parseLine(line) {
            // 若長度不足 81 則右補空白
            let paddedLine = line;
            if (paddedLine.length < 81) {
                paddedLine = paddedLine.padEnd(81, ' ');
            }

            const result = {};

            this.txtFormat.forEach((field) => {
                // JavaScript 字串是 0-based，因此 start - 1
                const value = paddedLine.slice(field.start - 1, field.end).trim();
                result[field.key] = value;
            });

            return result;
        },
        updateLineNumbers() {
            if (this.$refs.textarea) {
                this.totalLines = this.$refs.textarea.value.split('\n').length;
            } else {
                this.totalLines = 0;
            }
        },
        onInputTextarea() {
            this.updateLineNumbers();
            this.updateLineInfo();
        },
        handleTextareaScroll() {
            console.log(this.$refs.lineNumbersDiv);
            if (this.$refs.lineNumbersDiv && this.$refs.textarea) {
                this.$refs.lineNumbersDiv.scrollTop = this.$refs.textarea.scrollTop;
            }
        },
    },
};
</script>

<style lang="scss">
.business-tax-txt-viewer-page.ah-page {
    padding: 0;

    .line-viewer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        height: 70px;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        overflow-y: hidden;
        overflow-x: auto;

        .line-viewer-set {
            font-family: monospace;
            min-width: 1186px;

            >.text-row {
                display: flex;
                cursor: default;
                gap: 3px;

                >.data-section {
                    position: relative;
                    // padding: 5px;
                    background-color: #eee;
                    border-radius: 5px;
                    border: 1px solid green;

                    .field-label {
                        // position: absolute;
                        // top: -30px;
                        // left: 0;
                        // padding: 2px 10px;
                        // border-radius: 5px;
                        // white-space: nowrap;
                        // display: none;
                        // background-color: green;
                        // color: #fff;
                        // font-size: 10pt;
                        white-space: nowrap;
                        font-size: 9pt;
                        background-color: green;
                        color: #fff;
                        padding: 0 4px;
                    }

                    .field-data {
                        padding: 0 4px;
                    }

                    &:hover {
                        background-color: #fff;
                        border: 1px solid rgb(221, 88, 0);

                        .field-label {
                            background-color: rgb(221, 88, 0);
                        }
                    }
                }
            }
        }
    }

    .split-layout {
        display: grid;
        grid-template-columns: 50% 50%;
        height: calc(100vh - 172px - 70px);
    }
    .editor {
        position: relative;
        display: flex;
        height: 100%;
        font-size: 12px;
        font-family: monospace;
        border: 1px solid #ccc;
        overflow: hidden;
        background-color: #fff;

        .line-numbers {
            position: absolute;
            padding: 5px 0px 50px 0;
            line-height: 20px;
            background-color: #fff;
            height: 100%;
            width: 100%;
            overflow-y: auto;
            text-align: right;
            user-select: none;
            color: #888;
            border-right: 1px solid #ccc;

            &::-webkit-scrollbar {
                display: none;
            }

            >span {
                position: relative;
                display: block;
                width: 50px;
                height: 20px;
                padding: 0 10px;

                &.active {
                    background-color: green;
                    color: #fff;

                    &::before {
                        position: absolute;
                        top: 0;
                        left: 50px;
                        width: 50vw;
                        height: 100%;
                        content: '';
                        background-color: rgb(213, 233, 211);;
                    }
                }
            }
        }

        .textarea {
            border: 0;
            border-left: 1px solid #ccc;
            position: relative;
            margin-left: 50px;
            height: 100%;
            flex: 1;
            padding: 5px 10px;
            font-size: 13px;
            line-height: 20px;
            outline: none;
            resize: none;
            white-space: pre;
            overflow-wrap: normal;
            background-color: transparent;
            z-index: 1;
        }
    }
    .left-tab {
        .el-tabs__header {
            margin-bottom: 0;
        }
        .el-tabs__nav {
            margin-left: 15px;
        }
    }
    .left-content {
        height: calc(100vh - 172px - 70px);
        overflow-y: auto;
    }

    .def-table {
        table {
            border-collapse: collapse;
            width: 100%;
            font-size: 10.5pt;
        }
        th, td {
            border: 1px solid #ccc;
            padding: 4px;
            text-align: left;
        }
        thead {
            background-color: #ddd;
            white-space: nowrap;
        }
        code {
            background: #f9f9f9;
            padding: 2px 4px;
        }
        .data-field {
            min-height: 24px;
            display: block;
            background-color: #fff;
            padding: 0 8px;
            border-radius: 5px;
            font-family: monospace;
        }
    }
}
</style>
